module.exports = __webpack_public_path__ + "img/4.ae7d16ef.jpg";